import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import "./scrollbar.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import FinalImage from "./components/FinalImage";
import Home from "./components/Home";
import Context from "./context/context";
import { ToastContainer } from "react-toastify";
import {
  BRUSH_TOOL_ROUTE,
  CREATE_INSPIRATIONS_ROUTE,
  CREATE_INSPIRATIONS_WITH_ID_ROUTE,
  HOME_ROUTE,
} from "./Helpers/constants";
import BrushTool from "./components/BrushTool";
import { App } from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Context>
      <Router>
        <Routes>
          <Route path={HOME_ROUTE} exact Component={Home} />
          <Route path={CREATE_INSPIRATIONS_ROUTE} exact Component={App} />{" "}
          {/* App */}
          <Route path={BRUSH_TOOL_ROUTE} exact Component={BrushTool} />
          <Route
            path={CREATE_INSPIRATIONS_WITH_ID_ROUTE}
            Component={FinalImage}
          />
          <Route path={"*"} Component={Home} />
        </Routes>
      </Router>

      {/* Tostify */}
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        limit={1}
        hideProgressBar={true}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="dark"
      />
    </Context>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
